module.exports = __webpack_public_path__ + "static/media/ktm_zoom_finger.f9011963.gif";